import './ToDoError.css';

function ToDoError() {
  return (
    <p>Ha ocurrido un error.</p>
  );
}

export { ToDoError };